class InstanceSwiper extends HTMLElement {
  constructor() {
    super();
    this.handle = this.getAttribute("handle");
    this.swiperInitialized = false; // Prevent multiple initializations
  }

  static get observedAttributes() {
    return ['handle'];
  }

  init() {
    // Prevent multiple initializations
    if (this.swiperInitialized) return;
    this.swiperInitialized = true;

    this.options = this.setOptions();
    this.instance = new Swiper('.swiper--' + this.handle, this.options);
    this.setInteractions();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      window.addEventListener("shopify:section:load", () => this.init());
      window.addEventListener("shopify:section:select", () => this.init());

      // fallback initialization after delay in design mode
      setTimeout(() => {
        if (!this.swiperInitialized) this.init();
      }, 100);
    } else {
      // window.addEventListener("load", () => this.init());
      this.init();
    }
  }

  disconnectedCallback() {
    if (this.instance && this.instance.destroy) this.instance.destroy();
  }

  /**
   * Options before initialization
   */
  setOptions() {
    if (this.debug) console.log('setOptions');
    this._options = this.getOptionsAsJsonScripts();
    return this._options;
  }

  getOptionsAsJsonScripts() {
    if (this.debug) console.log('getOptionsAsJsonScripts');
    const jsonScriptAutomated = this.querySelector(`script#swiper--${this.handle}--automated-options`);
    const jsonScriptOverwrite = this.querySelector(`script#swiper--${this.handle}--overwrite-options`);
    let options = {};
    if (jsonScriptAutomated && jsonScriptAutomated.textContent) {
      try {
        options = { ...options, ...JSON.parse(jsonScriptAutomated.textContent) };
      } catch (error) {
        console.error('Error parsing JSON', error, jsonScriptAutomated?.textContent);
      }
    }
    if (jsonScriptOverwrite && jsonScriptOverwrite.textContent) {
      try {
        options = { ...options, ...JSON.parse(jsonScriptOverwrite.textContent) };
      } catch (error) {
        console.error('Error parsing JSON', error, jsonScriptOverwrite?.textContent);
      }
    }
    return options;
  }

  /** thumbs instance should be mounted before this instance */
  getThumbsInstance() {
    if (!this.isThumbsActive) return;
    return document.querySelector(`[handle="${this.getAttribute('thumbs')}"]`)?.instance;
  }

  /**
   * Interaction after initialization
   */
  setInteractions() {
    if (this.debug) console.log('setInteractions');
  }
}
// customElements.define('instance-swiper', InstanceSwiper);
class InstanceSwiperProductThumbs extends InstanceSwiper {
  constructor() {
    super();
  }

  setOptions() {
    super.setOptions();
    this.setCenteredSlides();
    return this._options;
  }

  setCenteredSlides() {
    if (this.handle !== 'product-thumbs') return;
    if (this.debug) console.log('setCenteredSlides');

    const afterInit = (swiper) => {
      if (swiper.activeIndex !== 0) swiper.slideTo(0);
      if (this.debug) console.log('afterInit');
      const swiperWrapper = swiper.wrapperEl;
      const observer = new MutationObserver(resetSwiperWrapperTransform);
      observer.observe(swiperWrapper, { attributes: true });
      function resetSwiperWrapperTransform() {
        if (
          swiperWrapper.hasAttribute('style') &&
          swiperWrapper.style?.transform &&
          swiperWrapper.style?.transform !== 'translate3d(0px, 0px, 0px)'
        ) {
          swiperWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
          if (this.debug) console.log('swiperWrapper observer removed styles!');
        } else if (
          swiperWrapper.hasAttribute('style') &&
          swiperWrapper.style?.transform &&
          swiperWrapper.style?.transform === 'translate3d(0px, 0px, 0px)'
        ) {
          setTimeout(() => {
            if (
              swiperWrapper.hasAttribute('style') &&
              swiperWrapper.style?.transform &&
              swiperWrapper.style?.transform === 'translate3d(0px, 0px, 0px)'
            ) {
              observer.disconnect();
              if (this.debug) console.log('swiperWrapper observer disconnect!');
            }
          }, 500);
        }
      }

      /**
       * Quick fix for thumbnails dislocationing issue
       * when thumbnails are less than the height of the wrapper
       */
      const calculateAllThumbHeight = (this.querySelector(".swiper-slide").clientHeight + 16) * this.querySelectorAll(".swiper-slide").length;
      const thumbsWrapper = this.parentElement;
      function setThumbsWrapperHeightToAuto() {
        if (thumbsWrapper.offsetHeight > calculateAllThumbHeight) {
          thumbsWrapper.style.height = (calculateAllThumbHeight - 16) + "px";
        } else {
          thumbsWrapper.removeAttribute("style");
        }
      }
      // window.addEventListener("resize", setThumbsWrapperHeightToAuto);
      // // have to wait global.js media area height css variables to be generated
      // setTimeout(() => {
      //   setThumbsWrapperHeightToAuto();
      // }, 2500);
      window.addEventListener("resize", setThumbsWrapperHeightToAuto);
      const applyThumbHeight = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(setThumbsWrapperHeightToAuto);
        });
      };
      if (document.readyState === 'loading') {
        document.addEventListener("DOMContentLoaded", applyThumbHeight);
      } else {
        applyThumbHeight();
      }
    };

    this._options = {
      ...this._options,
      on: {
        ...(this._options.on || {}),
        afterInit: afterInit,
      },
    };
  }

}
if (!customElements.get('swiper-product-thumbs')) {
  customElements.define('swiper-product-thumbs', InstanceSwiperProductThumbs);
}
class InstanceSwiperProductGallery extends InstanceSwiper {
  constructor() {
    super();
    this.isThumbsActive = this.hasAttribute("thumbs");
    this.isZoomActive = this.hasAttribute("zoom");
    this.modelViewerBtn = this.querySelector('.model-viewer-btn');
    this.modelViewer = this.querySelector('model-viewer');
    this.isModelActive = false;
  }

  static get observedAttributes() {
    return ["thumbs", "zoom"];
  }

  // 갤러리는 Swiper 대신 브라우저 기본 가로 스크롤로 그린다. 손가락을 따라
  // 좌표를 계산해 transform 을 다시 쓰는 대신 스크롤을 브라우저에 맡긴다.
  // 스크롤은 별도 스레드에서 처리돼 자바스크립트가 밀려도 끊기지 않는다.
  //
  // 되돌릴 길은 남겨 둔다 — 주소에 ?swiper-gallery=1 을 붙이면 옛 경로를 탄다.
  static isNativeRequested() {
    try {
      return new URLSearchParams(window.location.search).get('swiper-gallery') !== '1';
    } catch (error) {
      return true;
    }
  }

  static injectNativeStyle() {
    if (document.getElementById('gallery-native-style')) return;
    const style = document.createElement('style');
    style.id = 'gallery-native-style';
    // 한 화면에 몇 장이 걸쳐 보이는지는 원래 Swiper 옵션에서 받아 변수로 넘긴다.
    // 값을 여기 적어두면 섹션 설정이 다른 상품에서 레이아웃이 어긋난다.
    //
    // 실제로 쓰는 --native-per-view / --native-gap 은 여기서만 정한다. 요소에 직접
    // 쓴 값은 스타일시트를 항상 이기므로, 이 둘을 인라인으로 박으면 아래 데스크톱
    // 규칙이 영영 발동하지 못한다. 옵션에서 읽은 값은 -sm / -wide 로만 넘긴다.
    style.textContent =
      // text-size-adjust: iOS Safari 가 스크롤 컨테이너 안 글자를 스스로 키우는 것을 막는다.
      // 근거는 global.js 의 .native-slider 주석과 같다.
      '.gallery-native{overflow-x:auto!important;overflow-y:hidden!important;' +
      'scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;' +
      '-webkit-text-size-adjust:100%;text-size-adjust:100%;' +
      '--native-per-view:var(--native-per-view-sm,1);--native-gap:var(--native-gap-sm,0px);}' +
      '.gallery-native::-webkit-scrollbar{display:none;}' +
      '.gallery-native .swiper-wrapper{display:flex!important;transform:none!important;' +
      'width:auto!important;gap:var(--native-gap,0px);}' +
      '.gallery-native .swiper-slide{flex:0 0 calc((100% - var(--native-gap,0px) * ' +
      '(var(--native-per-view,1) - 1)) / var(--native-per-view,1));scroll-snap-align:start;}' +
      '@media (min-width:750px){.gallery-native{--native-per-view:var(--native-per-view-wide);' +
      '--native-gap:var(--native-gap-wide);}}' +
      '.gallery-native .swiper-buttons{display:none;}';
    document.head.appendChild(style);
  }

  init() {
    if (!InstanceSwiperProductGallery.isNativeRequested()) {
      super.init();
      return;
    }
    if (this.swiperInitialized) return;
    this.swiperInitialized = true;
    this.initNativeScroll();
  }

  initNativeScroll() {
    const track = this.querySelector('.swiper-wrapper');
    const viewport = track && track.closest('.swiper');
    if (!viewport) return;

    InstanceSwiperProductGallery.injectNativeStyle();
    this.applyNativeLayoutVars(viewport);
    viewport.classList.add('gallery-native');
    this.nativeViewport = viewport;
    // wrapper 안에는 슬라이드 말고 다른 요소도 섞여 있어 자식을 그대로 쓰면 어긋난다.
    this.nativeSlides = Array.from(track.querySelectorAll(':scope > .swiper-slide'));

    this.holdNativeSnapUntilLoaded();
    this.trackNativeUserScroll();
    this.guardNativeScrollIntoView();
    this.bindNativeThumbs();
    // 확대는 Swiper 인스턴스를 쓰지 않으므로 그대로 붙인다.
    if (this.isZoomActive) {
      if (this.isPhotoSwipeReady()) {
        this.photoSwipeLightboxInit();
      } else {
        document.addEventListener(
          "DOMContentLoaded",
          () => {
            if (this.isPhotoSwipeReady()) this.photoSwipeLightboxInit();
          },
          { once: true }
        );
      }
    }
  }

  applyNativeLayoutVars(viewport) {
    let options = {};
    try {
      options = this.getOptionsAsJsonScripts() || {};
    } catch (error) {
      options = {};
    }
    const wide = (options.breakpoints && options.breakpoints['750']) || {};
    const perView = Number(options.slidesPerView) || 1;
    const gap = Number(options.spaceBetween) || 0;
    viewport.style.setProperty('--native-per-view-sm', String(perView));
    viewport.style.setProperty('--native-gap-sm', gap + 'px');
    viewport.style.setProperty('--native-per-view-wide', String(Number(wide.slidesPerView) || perView));
    viewport.style.setProperty('--native-gap-wide', (Number(wide.spaceBetween) || gap) + 'px');
  }

  // 캐시가 빈 첫 로딩에서만 나던 증상을 막는다. 이미지가 늦게 도착하면 그 순간
  // 레이아웃이 다시 잡히는데, 스냅이 걸려 있으면 브라우저가 스냅 지점으로 강제로
  // 되돌린다. 끝까지 밀어 둔 자리가 첫 장으로 튀면서 깜빡이는 것이 그것이다.
  // 다 들어온 뒤에 스냅을 건다. 새로고침 때 증상이 없던 것은 캐시가 차 있어
  // 레이아웃이 처음부터 확정돼 있었기 때문이다.
  holdNativeSnapUntilLoaded() {
    const view = this.nativeViewport;
    view.style.scrollSnapType = 'none';

    // 화면 밖 이미지는 lazy 라 끝내 오지 않는다. 그것까지 기다리면 스냅이 영영
    // 꺼진 채 남는다. 레이아웃을 흔드는 것은 지금 그려지는 것들뿐이다.
    const pending = Array.from(view.querySelectorAll('img'))
      .filter(img => !img.complete && img.getAttribute('loading') !== 'lazy');

    let released = false;
    const release = () => {
      if (released) return;
      released = true;
      clearTimeout(this.nativeSnapTimer);
      view.style.scrollSnapType = '';
    };
    if (!pending.length) { release(); return; }

    let remaining = pending.length;
    const settle = () => { remaining -= 1; if (remaining <= 0) release(); };
    pending.forEach(img => {
      img.addEventListener('load', settle, { once: true });
      img.addEventListener('error', settle, { once: true });
    });

    // 한 장이라도 응답이 오지 않으면 스냅이 계속 꺼진 채다. 뒷문을 둔다.
    this.nativeSnapTimer = setTimeout(release, 5000);
  }

  // 손으로 민 것과 코드가 옮긴 것을 갈라 둔다. 갈라두지 않으면 아래에서
  // 둘을 구분할 수 없어, 사용자가 밀어 둔 자리를 페이지가 도로 빼앗는다.
  trackNativeUserScroll() {
    this.nativeViewport.addEventListener('scroll', () => {
      if (this.nativeProgrammaticScroll) return;
      this.nativeUserScrolled = true;
    }, { passive: true });

    // global.js 는 갤러리를 맞출 때 썸네일을 코드로 눌러버린다(tryThumbClick).
    // 그것까지 사람이 누른 것으로 치면 가드가 통째로 뚫리므로 isTrusted 로 가른다.
    // 판별만 여기서 하고 처리는 갈라 둔다 — 합쳐 두면 검사할 수가 없다.
    document.addEventListener('click', event => {
      if (!event.isTrusted) return;
      this.handleHumanClick(event.target);
    }, { capture: true, passive: true });
  }

  // 갤러리 밖을 눌렀다면 변형이나 썸네일을 고른 것이다. 밀어 둔 자리를 고집할
  // 이유가 없어졌으므로 상태를 푼다. 갤러리 안을 누른 것은 확대하려는 것이므로 둔다.
  //
  // 시각으로 재지 않는 이유: 변형을 고르고 이미지가 바뀌기까지 걸리는 시간은
  // 상품마다 다르다. 창을 좁게 잡으면 느린 상품에서 이동이 통째로 막힌다.
  handleHumanClick(target) {
    if (!this.nativeViewport) return;
    if (target && this.nativeViewport.contains(target)) return;
    this.nativeUserScrolled = false;
  }

  // 변형 드롭다운이 동기화될 때 global.js 가 선택된 미디어에 scrollIntoView 를 건다.
  // Swiper 를 쓸 때는 overflow-x 가 hidden 이라 화면이 움직이지 않았는데, 브라우저
  // 기본 스크롤로 바꾸면 이 한 줄이 갤러리를 실제로 끌고 가 첫 장으로 되돌린다.
  // 사용자가 이미 밀어 둔 뒤 페이지가 스스로 부르는 이동만 걸러낸다.
  guardNativeScrollIntoView() {
    const nodes = this.nativeViewport.querySelectorAll('[data-media-id]');
    nodes.forEach(node => {
      if (node.nativeScrollGuarded) return;
      node.nativeScrollGuarded = true;
      const original = node.scrollIntoView.bind(node);
      node.scrollIntoView = options => {
        if (this.nativeUserScrolled) return;
        original(options);
      };
    });
  }

  scrollToNativeIndex(index, options) {
    const slide = this.nativeSlides && this.nativeSlides[index];
    if (!slide || !this.nativeViewport) return;

    // 사용자가 이미 갤러리를 밀어 둔 뒤라면, 페이지가 스스로 부른 이동은 무시한다.
    // 변형을 눌러서 바뀐 것은 직전 클릭이 있으므로 그대로 따라간다.
    if ((!options || !options.byUser) && this.nativeUserScrolled) return;

    this.nativeProgrammaticScroll = true;
    this.nativeViewport.scrollTo({
      left: slide.offsetLeft - this.nativeViewport.offsetLeft,
      behavior: 'smooth'
    });
    clearTimeout(this.nativeScrollSettle);
    this.nativeScrollSettle = setTimeout(() => {
      this.nativeProgrammaticScroll = false;
    }, 600);
  }

  bindNativeThumbs() {
    if (!this.isThumbsActive) return;
    const thumbs = document.querySelector('swiper-product-thumbs');
    if (!thumbs) return;
    thumbs.addEventListener('click', event => {
      const slide = event.target.closest('[data-index]');
      if (!slide) return;
      this.scrollToNativeIndex(Number(slide.dataset.index), { byUser: event.isTrusted });
    });
  }

  setOptions() {
    super.setOptions();
    this.setThumbOptions();
    return this._options;
  }

  setThumbOptions() {
    if (!this.isThumbsActive) return;
    if (this.debug) console.log("setThumbOptions");
    const thumbsInstance = super.getThumbsInstance();
    if (this.debug) console.log("thumbsInstance", thumbsInstance);
    this._options = {
      ...this._options,
      thumbs: {
        swiper: thumbsInstance
      }
    };
  }

  /**
   * Interaction after initialization
   */
  setInteractions() {
    if (this.isThumbsActive) this.setThumbsInteraction();
    // 확대 라이브러리는 상품 섹션 안에서 로드되는데 이 스크립트는 그보다 먼저 실행된다.
    // 아직 없는 상태에서 곧바로 붙이면 여기서 멈춰 아래 모델 뷰어까지 초기화되지 않으므로,
    // 없으면 나머지 스크립트가 다 끝나는 시점을 기다렸다가 붙인다.
    if (this.isZoomActive) {
      if (this.isPhotoSwipeReady()) {
        this.photoSwipeLightboxInit();
      } else {
        document.addEventListener(
          "DOMContentLoaded",
          () => {
            if (this.isPhotoSwipeReady()) this.photoSwipeLightboxInit();
          },
          { once: true }
        );
      }
    }
    this.initModelViewer();

    // Add thumb click handler for model slides — only if product actually
    // has 3D model slides. The vast majority of cosmetics products don't,
    // and this avoided an unconditional document.querySelectorAll on init.
    // Scoped to `this` (the gallery instance) so multiple galleries on the
    // same page (e.g. recently-viewed overlay) don't cross-wire.
    const modelThumbSlides = this.querySelectorAll('.swiper-slide[data-media-type="model"]');
    if (modelThumbSlides.length > 0) {
      modelThumbSlides.forEach(slide => {
        slide.addEventListener('click', () => this.enableSwiper());
      });
    }

    // Force pagination update on mobile after each slide change
    this.instance.on("slideChange", swiper => {
      if (window.innerWidth < 750) {
        swiper.pagination.update();
        if (this.debug) console.log("Pagination updated manually on mobile.");
      }
    });

    // Detect scroll event and force update pagination when scrolling ends
    this.instance.on("scroll", swiper => {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        swiper.pagination.update();
        if (this.debug) console.log("Pagination updated after scroll.");
      }, 200);
    });
  }

  initModelViewer() {
    // Find all swiper slides with model viewers
    const modelSlides = this.querySelectorAll('.swiper-slide[data-media-type="model"]');
    // Early return when the product has no 3D models — avoids attaching
    // nav-button reset handlers (and their per-click querySelectorAll via
    // resetAllModelViewers) for every non-model PDP. Significant TBT win
    // because most catalog products (cosmetics, beauty) have no models.
    if (modelSlides.length === 0) return

    modelSlides.forEach(slide => {
      const btn = slide.querySelector('.model-viewer-btn');
      const container = slide.querySelector('.model-viewer-container');
      const modelViewer = container?.querySelector('model-viewer');

      if (btn && container && modelViewer) {
        // Store references to associated elements
        btn.modelViewer = modelViewer;
        modelViewer.controlButton = btn;

        // Model viewer container click handler
        container.addEventListener('click', (e) => {
          if (!btn.classList.contains('is-active')) {
            e.preventDefault();
            e.stopPropagation();
            btn.click();
          }
        });

        // Model viewer button click handler
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleModelViewer(btn, modelViewer);
        });

        // Prevent model-viewer direct interaction
        modelViewer.addEventListener('mousedown', (e) => {
          if (!btn.classList.contains('is-active')) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }
    });

    // Add navigation click handlers
    if (this.instance.navigation) {
      const { nextEl, prevEl } = this.instance.navigation;
      if (nextEl) {
        nextEl.addEventListener('click', () => {
          this.resetAllModelViewers();
          this.enableSwiper(true);
        });
      }
      if (prevEl) {
        prevEl.addEventListener('click', () => {
          this.resetAllModelViewers();
          this.enableSwiper(true);
        });
      }
    }
  }

  resetAllModelViewers() {
    // Find all model viewers in the current gallery instance
    const modelSlides = this.querySelectorAll('.swiper-slide[data-media-type="model"]');

    modelSlides.forEach(slide => {
      const btn = slide.querySelector('.model-viewer-btn');
      const modelViewer = slide.querySelector('model-viewer');

      if (btn && modelViewer) {
        btn.classList.remove('is-active');
        modelViewer.interactionPrompt = 'none';
        modelViewer.cameraControls = false;
      }
    });

    this.isModelActive = false;
    this.instance.allowTouchMove = true;
  }

  toggleModelViewer(btn, modelViewer) {
    const wasActive = btn.classList.contains('is-active');

    // Reset all model viewers in this gallery
    this.resetAllModelViewers();

    if (!wasActive) {
      this.isModelActive = true;
      this.instance.allowTouchMove = false;

      // Enable only this specific model viewer
      modelViewer.interactionPrompt = 'auto';
      modelViewer.cameraControls = true;
      btn.classList.add('is-active');
    }
  }

  temporarilyDisableSwiper() {
    // Only disable touch/mouse dragging
    this.instance.allowTouchMove = false;

    // Re-enable after a short delay if no model interaction occurs
    this.swiperTimeout = setTimeout(() => {
      if (!this.isModelActive) {
        this.enableSwiper();
      }
    }, 100);
  }

  enableSwiper(force = false) {
    if (this.swiperTimeout) {
      clearTimeout(this.swiperTimeout);
    }

    // Always enable touch/mouse dragging if force is true (navigation/thumb clicks)
    if (force || !this.isModelActive) {
      this.instance.allowTouchMove = true;

      // Reset model viewer state if forced
      if (force && this.isModelActive) {
        this.isModelActive = false;
        if (this.modelViewer) {
          this.modelViewer.interactionPrompt = 'none';
          this.modelViewer.cameraControls = false;
        }
        // Guard: modelViewerBtn may be null on products without 3D models.
        // In practice this branch never runs for them (isModelActive stays
        // false), but optional-chaining makes it null-safe regardless.
        this.modelViewerBtn?.classList.remove('is-active');
      }
    }
  }

  setThumbsInteraction() {
    if (!this.isThumbsActive || !this.instance) return;
    if (this.debug) console.log("setThumbsInteraction");
    const thumbsSwiper = this.options.thumbs.swiper;

    // Enable swiper on thumb click
    thumbsSwiper.el.addEventListener('click', () => {
      this.enableSwiper(true);
      // Guard: products without 3D models don't render .model-viewer-btn,
      // so this.modelViewerBtn is null. Prior unguarded access would throw
      // a TypeError on every thumb click for non-model PDPs.
      this.modelViewerBtn?.classList.remove('btn--active');
    });

    this.instance.on("slideChangeTransitionStart", function (swiper) {
      const activeIndex = swiper.activeIndex;
      const thumbsActiveIndex = thumbsSwiper.activeIndex;
      if (this.debug) console.log("slideChangeTransitionStart", activeIndex, thumbsActiveIndex);
      if (activeIndex !== thumbsActiveIndex) {
        thumbsSwiper.slideTo(activeIndex);
      }
    });
  }

  isPhotoSwipeReady() {
    return (
      typeof PhotoSwipeLightbox !== "undefined" && typeof PhotoSwipe !== "undefined"
    );
  }

  photoSwipeLightboxInit() {
    const [
      zoomContainerWidth,
      zoomContainerHeight,
      closeIcon,
      prevIcon,
      nextIcon
    ] = [
      this.offsetWidth,
      this.offsetHeight,
      document.querySelector("[data-close-icon]"),
      document.querySelector("[data-prev-icon]"),
      document.querySelector("[data-next-icon]")
    ];

    function isPhone() {
      return window.innerWidth < 750;
    }

    const photoSwipeLightboxInstance = new PhotoSwipeLightbox({
      gallery: `.photoswipe-wrapper`,
      children: "a.product__gallery-toggle",
      mainClass: "pswp--product-media-gallery",

      loop: false,
      showHideAnimationType: "zoom",

      initialZoomLevel: zoomLevelObject => {
        if (isPhone()) {
          return zoomLevelObject.vFill;
        } else {
          return zoomLevelObject.fit;
        }
      },
      secondaryZoomLevel: zoomLevelObject => {
        if (isPhone()) {
          return zoomLevelObject.fit;
        } else {
          return 1;
        }
      },
      pswpModule: PhotoSwipe
    });
    photoSwipeLightboxInstance.addFilter(
      "uiElement",
      (element, data) => {
        if (data.name === "close") {
          element.innerHTML = closeIcon.innerHTML;
        } else if (data.name === "arrowPrev") {
          element.innerHTML = prevIcon.innerHTML;
        } else if (data.name === "arrowNext") {
          element.innerHTML = nextIcon.innerHTML;
        }
        return element;
      }
    );

    // html for video
    photoSwipeLightboxInstance.addFilter(
      "itemData",
      (itemData, index) => {
        if (itemData.type === "html" && itemData.element) {
          return {
            html: itemData.element.dataset.pswpHtml
          };
        }
        return itemData;
      }
    );

    photoSwipeLightboxInstance.init();

    photoSwipeLightboxInstance.on("beforeOpen", () => {
      document.body.classList.add("oveflow-hidden");
      const videos = this.querySelectorAll("video");
      Array.from(videos).forEach(video => {
        // if video is not playing, call playPromise
        // force to play
        video
          .play()
          .then(() => {
            // Automatic playback started!
            // Show playing UI.
            // video.play();
          })
          .catch(error => {
            // Auto-play was prevented
            // Show paused UI.
            video.pause();
          });
      });
    });

    photoSwipeLightboxInstance.on("closingAnimationStart", () => {
      document.body.classList.remove("oveflow-hidden");
    });
  }

  setActiveMedia(id) {
    const mediaFound = Array.from(
      this.querySelectorAll("[data-media-id]")
    ).find(media => Number(media.dataset.mediaId) === id);

    if (!mediaFound) return;

    if (this.nativeViewport) {
      if (this.dataset.hideOtherVariantsMedia === 'false') {
        this.scrollToNativeIndex(Number(mediaFound.dataset.index));
      }
      return;
    }

    if (this.instance && typeof this.instance.slideTo === 'function') {
      if (this.dataset.hideOtherVariantsMedia === 'false') {
        this.instance.slideTo(Number(mediaFound.dataset.index));
      }
    }
  }
}
if (!customElements.get('swiper-product-gallery')) {
  customElements.define('swiper-product-gallery', InstanceSwiperProductGallery);
}


class ProductMediaInfo extends HTMLElement {
  constructor() {
    super();
    this.init();
    window.addEventListener("resize", this.init.bind(this));
    if (Shopify.designMode) {
      window.addEventListener("shopify:section:load", this.init.bind(this));
    }
  }

  init() {
    let containerOffsetWidth = document.querySelector('.main-product__media--slider').offsetWidth || 330;
    if (document.querySelector('.main-product__media--grid-item') && window.innerWidth > 750) {
      containerOffsetWidth = document.querySelector('.main-product__media--grid-item').offsetWidth;
    }
    const maxWidthForInfo = (containerOffsetWidth - 48) / 2;

    const mediaInfoTextWidth = this.querySelector('p:last-child').offsetWidth;
    const mediaInfoHidden = this.querySelector('p[aria-hidden]');

    if (mediaInfoTextWidth > maxWidthForInfo) {
      this.classList.remove('animation-stopped');
      this.style.cssText = `--marquee-speed: ${mediaInfoTextWidth / maxWidthForInfo * 8}s`;
      mediaInfoHidden.style.display = '';
    } else {
      this.classList.add('animation-stopped');
      this.style.cssText = '';
      mediaInfoHidden.style.display = 'none';
    }
  }
}

if (!customElements.get('product-media-info')) {
  customElements.define('product-media-info', ProductMediaInfo);
}


